var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavPilot2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-3{fill:none}.cls-1{stroke:#b1b1c9}.cls-2{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3184",
    transform: "translate(-36 -351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2424",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H4V12H0z",
    className: "cls-2",
    transform: "translate(36 356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H3.5V11.5H0.5z",
    className: "cls-3",
    transform: "translate(36 356)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2425",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H4V17H0z",
    className: "cls-2",
    transform: "translate(42 351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H3.5V16.5H0.5z",
    className: "cls-3",
    transform: "translate(42 351)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2426",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H4V13H0z",
    className: "cls-2",
    transform: "translate(48 355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H3.5V12.5H0.5z",
    className: "cls-3",
    transform: "translate(48 355)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPilot2);
export default __webpack_public_path__ + "static/media/nav-pilot-2.9a8b3f4cf698cfb9053e7a7f00158f30.svg";
export { ForwardRef as ReactComponent };